(function(){

  async function init_image_with_text() {
    await MB_waitElementReady(".image_with_text_buttons a");
    
    // 获取所有匹配的 h2 元素
    const elements = document.querySelectorAll(".image_with_text_buttons a");
    const banners = document.querySelectorAll("main>div[id*=image_with_text]");
    
    // 为每个元素添加点击事件监听器
    elements.forEach((element, index) => {
      element.addEventListener('click', function(e) {
        title_click_handler(e, this);
      });
    });
    // 为每个元素添加鼠标悬停事件监听器
    // elements.forEach((element, index) => {
    //   element.addEventListener('mouseenter', function(e) {
    //     title_hover_handler(this);
    //   });
    // });

    function title_click_handler(e, element) {
      if(e) e.preventDefault();
      element.classList.add('is_selected');
      const index = Array.from(elements).indexOf(element);
      banner = banners[index];
      console.log(banner)
      banners.forEach(el => {
        el.classList.remove('is_selected');
      });
      banner.classList.add('is_selected');
    }

    title_click_handler(null, elements[0]);
    
  }
  document.addEventListener('DOMContentLoaded', function(){
    console.log("DOMContentLoaded")
    init_image_with_text()
  })
}())